// Enlace a Google Maps para "Cómo llegar" a una dirección de San Juan
export const comoLlegar = (direccion, nombre) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([nombre, direccion, 'San Juan, Argentina'].filter(Boolean).join(', '))}`;

export const mapaPunto = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;

export const whatsappEnlace = (numero, texto) =>
  `https://wa.me/${numero || ''}?text=${encodeURIComponent(texto)}`;
